// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import React from "react";

import {
  getIdToken,
  onAuthStateChanged,
  getAuth,
  signOut,
} from "firebase/auth";
import Axios from "axios";
import { environment, apiRoutes } from "./apiRoute";

Axios.defaults.withCredentials = true;
const withAuthProvider = (WrappedComponent) => {
  const auth = getAuth();

  class authComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isAcceptingNomination: false,
        isJudgingNomination: true,
        isFinalJudgingNomination: false,
        error: null,
        isAuthenticated: false,
        isLoading: true,
        user: null,
      };
    }

    authenticatedUser = async () => {
      // Axios.post(apiRoutes[environment].auth, {
      //   withCredentials: true,
      //   credentials: "include",
      // });
      console.log("Authenticating user");
      onAuthStateChanged(auth, async (currentUser) => {
        // if (currentUser && currentUser.uid == this.state.user.uid) {
        //   return;
        // }
        if (currentUser) {
          var user = {
            id: null,
            uid: currentUser.uid,
            accessToken: currentUser.accessToken,
            phoneNumber: currentUser.phoneNumber,
            email: currentUser.email,
            displayName: currentUser.displayName,
            roles: [],
            judgePendingApproval: false,
          };
          // const token = await getIdToken(currentUser, true);
          // console.log(token);
          const resp = await Axios.post(apiRoutes[environment].login, {
            idToken: user.accessToken,
          });
          const userProfile = resp.data;

          if (!resp.data._id) {
            // window.location = "/member/new/profile";
            user.id = null;
          } else {
            user.id = userProfile._id;
            user.roles = userProfile.roles;
            user.judgePendingApproval = userProfile.judgePendingApproval;
            if (!user.displayName) {
              user.displayName =
                userProfile.firstName + " " + userProfile.lastName;
            }
          }

          this.setState({
            user: user,
            isAuthenticated: true,
            isLoading: false,
          });
        } else {
          this.setState({
            user: null,
            isAuthenticated: false,
            isLoading: false,
          });
        }
        this.setState({ isLoading: false });
      });
    };
    // authenticatedUser = () => {
    //   return Axios.post(apiRoutes[environment].auth, {
    //     withCredentials: true,
    //     credentials: "include",
    //   })
    //     .then((resp) => {
    //       this.setState({
    //         user: resp.data,
    //         isAuthenticated: resp.data.isAuthenticated,
    //         isLoading: false,
    //       });
    //       console.log(resp.data);
    //       return resp.data;
    //     })
    //     .catch((err) => {
    //       this.setState({
    //         user: null,
    //         isAuthenticated: false,
    //         isLoading: false,
    //       });
    //       console.log(err.data);
    //       return err.data;
    //     });
    // };
    async componentDidMount() {
      this.authenticatedUser();
      this.getSettings();
    }

    async getSettings() {
      try {
        const res = await Axios.get(apiRoutes["admin/settings"]);
        for (const setting of res.data) {
          this.setState({ [setting.name]: setting.value });
        }
      } catch (error) {
        console.log(error);
      }
    }
    async login(data) {
      // history.push("/sso/login");
      // window.location = "/login";
      console.log(data);

      var user = {
        id: data.id,
        uid: data.uid,
        accessToken: data.accessToken,
        phoneNumber: data.phoneNumber,
        email: data.email,
        displayName: data.displayName,
      };

      this.setState({ isLoading: false, isAuthenticated: true, user: user });
    }
    async logout() {
      signOut(auth)
        .then(() => {
          Axios.post(apiRoutes[environment].logout);
          // Sign-out successful.
          console.log("signed out");
          this.setState({
            user: "",
            isAuthenticated: false,
          });
        })
        .catch((error) => {
          // An error happened.
          console.log(error);
        });
      // Axios.post(apiRoutes[environment].logout, {
      //   withCredentials: true,
      //   credentials: "include",
      // }).then((resp) => {
      //   this.setState({
      //     user: "",
      //     isAuthenticated: false,
      //   });
      //   window.location = "/login";
      // });
    }
    render() {
      return (
        <WrappedComponent
          error={this.state.error}
          isAcceptingNomination={this.state.isAcceptingNomination}
          isJudgingNomination={this.state.isJudgingNomination}
          isFinalJudgingNomination={this.state.isFinalJudgingNomination}
          isAuthenticated={this.state.isAuthenticated}
          isLoading={this.state.isLoading}
          user={this.state.user}
          login={(data) => this.login(data)}
          logout={() => this.logout()}
          getAccessToken={(scopes) => this.getAccessToken(scopes)}
          setError={(message, debug) => this.setErrorMessage(message, debug)}
          {...this.props}
        />
      );
    }
  }

  return authComponent;
};

export default withAuthProvider;
